/* Datos estáticos reutilizables en el frontend. */

// Zonas de trabajo (ejemplo: Arequipa). Ajusta según tu mercado.
export const WORK_ZONES = [
  'Cercado de Arequipa',
  'Cayma',
  'Yanahuara',
  'Cerro Colorado',
  'José Luis Bustamante y Rivero',
  'Paucarpata',
  'Miraflores',
  'Mariano Melgar',
  'Socabaya',
  'Alto Selva Alegre',
  'Jacobo Hunter',
  'Sachaca',
];

// Búsquedas sugeridas en el home.
export const POPULAR_SEARCHES = [
  'Gasfitero',
  'Electricista',
  'Pintor',
  'Albañil',
  'Mayólica',
  'Remodelación',
  'Maestro de obra',
];

// WhatsApp de Cuadrilla Maestra: todo contacto directo pasa primero por aquí.
export const PLATFORM_WHATSAPP = process.env.REACT_APP_PLATFORM_WHATSAPP || '+51913412527';

// Enlace al WhatsApp de Cuadrilla Maestra indicando qué maestro eligió el cliente.
export const platformWhatsappLink = (worker, origin = window.location.origin) => {
  const number = PLATFORM_WHATSAPP.replace(/\D/g, '');
  const trade = worker.headline || worker.category_name;
  const message =
    `Hola Cuadrilla Maestra, quiero contactar al maestro ${worker.name}` +
    `${trade ? ` (${trade})` : ''}. Perfil #${worker.id}: ${origin}/maestros/${worker.id}`;
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
};
